import { FunnelSimple, X } from "@phosphor-icons/react";
import { EMPTY_FILTERS } from "./KanbanFilterModal";

function FilterChip({ label, onClear, testid }) {
  return (
    <span className="inline-flex items-center gap-1.5 bg-black text-white text-[10px] font-bold uppercase tracking-widest px-2 py-1" data-testid={testid}>
      {label}
      <button type="button" onClick={onClear} className="hover:text-red-400" aria-label={`Remover filtro ${label}`}><X size={12} weight="bold" /></button>
    </span>
  );
}

export default function KanbanActiveFilters({ advFilters, setAdvFilters }) {
  return (
    <div className="mb-3 flex items-center gap-2 flex-wrap" data-testid="kanban-active-filters">
      <FunnelSimple size={14} weight="bold" />
      {advFilters.customer && <FilterChip label={`Cliente: ${advFilters.customer}`} onClear={() => setAdvFilters((p) => ({ ...p, customer: "" }))} testid="kanban-chip-customer" />}
      {advFilters.silk && <FilterChip label={`Silk: ${advFilters.silk}`} onClear={() => setAdvFilters((p) => ({ ...p, silk: "" }))} testid="kanban-chip-silk" />}
      {advFilters.cupColor && <FilterChip label={`Cor copo: ${advFilters.cupColor}`} onClear={() => setAdvFilters((p) => ({ ...p, cupColor: "" }))} testid="kanban-chip-cup-color" />}
      {advFilters.sku && <FilterChip label={`SKU: ${advFilters.sku}`} onClear={() => setAdvFilters((p) => ({ ...p, sku: "" }))} testid="kanban-chip-sku" />}
      {advFilters.overdueOnly && <FilterChip label="Somente atrasados" onClear={() => setAdvFilters((p) => ({ ...p, overdueOnly: false }))} testid="kanban-chip-overdue" />}
      {advFilters.stoppedDays && <FilterChip label={`Parado > ${advFilters.stoppedDays}d`} onClear={() => setAdvFilters((p) => ({ ...p, stoppedDays: "" }))} testid="kanban-chip-stopped" />}
      {(advFilters.deadlineStart || advFilters.deadlineEnd) && (
        <FilterChip
          label={`Limite: ${advFilters.deadlineStart ? advFilters.deadlineStart.split("-").reverse().slice(0, 2).join("/") : "…"} – ${advFilters.deadlineEnd ? advFilters.deadlineEnd.split("-").reverse().slice(0, 2).join("/") : "…"}`}
          onClear={() => setAdvFilters((p) => ({ ...p, deadlineStart: "", deadlineEnd: "" }))}
          testid="kanban-chip-deadline"
        />
      )}
      <button
        type="button"
        onClick={() => setAdvFilters(EMPTY_FILTERS)}
        className="text-[10px] font-bold uppercase tracking-widest underline text-zinc-500 hover:text-black"
        data-testid="kanban-clear-filters"
      >
        Limpar todos
      </button>
    </div>
  );
}
